import { TextField } from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import { API, SERVER_DOMAIN } from "../../assets/staticData";
import SuccessAlert from "../../components/success-alert/SuccessAlert";
import ErrorAlert from "../../components/error-alert/ErrorAlert";
import useLanguages from "../../hooks/useLanguages";
import addImageIcon from "../../assets/icons/add-image.png";

let userToken = localStorage.getItem("userToken");

export default function TutorialVideos({ index }) {
  const langs = useLanguages();

  const [vidLinks, setVidLinks] = useState([]);

  const [success, setSuccess] = useState(false);
  const [fail, setFail] = useState(false);
  const [thumbs, setThumbs] = useState([...Array(5)]);
  const [clickedIndex, setClickedIndex] = useState();

  const hiddenFileInputs = useRef([]);

  useEffect(() => {
    let docs = langs.map((item) => ({
      vids: [
        { title: "", link: "", thumbnail: "" },
        { title: "", link: "", thumbnail: "" },
        { title: "", link: "", thumbnail: "" },
        { title: "", link: "", thumbnail: "" },
        { title: "", link: "", thumbnail: "" },
      ],
      language: item.attributes.language,
    }));
    setVidLinks(docs);
    async function getData() {
      await fetch(`${API}/help-center`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      }).then(async (res) => {
        const response = await res.json();

        // const apiData = response.data?.attributes?.vidLinks || [];

        // setVidLinks((prevData) => {
        //   return prevData.map((localItem) => {
        //     const apiItem = apiData.find((apiItem) => apiItem.language === localItem.language);

        //     if (apiItem) {
        //       return {
        //         ...localItem,
        //         vids: apiItem.vids || localItem.vids,
        //       };
        //     } else {
        //       return localItem;
        //     }
        //   });
        // });

        setVidLinks(response.data?.attributes?.vidLinks || []);
      });
    }

    getData();
  }, []);

  const submitData = async () => {
    const uploadedThumbs = await Promise.all(
      thumbs.map(async (thumb) => {
        if (thumb) {
          const formData = new FormData();
          formData.append("files", thumb);
          const response = await fetch(`${API}/upload`, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${userToken}`,
            },
            body: formData,
          });
          const result = await response.json();
          return result[0]?.url;
        }
        return null;
      })
    );

    const updatedVidLinks = vidLinks.map((vidLink, i) => {

      if (index !== i) return vidLink

      return {
        ...vidLink,
        vids: vidLink.vids.map((vid, j) => ({
          ...vid,
          thumbnail: uploadedThumbs[j] || vid.thumbnail,
        }))
      }
    });

    await fetch(`${API}/help-center`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: { vidLinks: updatedVidLinks },
      }),
    }).then(async (res) => {
      if (res.ok) {
        setSuccess(true);
      } else {
        setFail(true);
      }
    });
  };

  // Handler for title change
  const handleTitleChange = (index, idx, newValue) => {
    const updatedLinks = [...vidLinks];
    updatedLinks[index].vids[idx].title = newValue;
    setVidLinks(updatedLinks);
  };

  // Handler for link change
  const handleLinkChange = (index, idx, newValue) => {
    const updatedLinks = [...vidLinks];
    updatedLinks[index].vids[idx].link = newValue;
    setVidLinks(updatedLinks);
  };

  const handleImageChange = (e, idx) => {
    const file = e.target.files[0];
    if (file) {
      let thumbsDocs = [...thumbs];
      thumbsDocs[idx] = file;
      setThumbs(thumbsDocs);
      console.log(thumbsDocs);
    }
  };

  return (
    <div className="flex-col">
      <SuccessAlert show={success} setShow={(v) => setSuccess(v)} />
      <ErrorAlert show={fail} setShow={(v) => setFail(v)} />

      {vidLinks[index]?.vids.map((item, idx) => (
        <div
          key={idx}
          className="flex"
          style={{
            gap: 25,
            alignSelf: "flex-start",
            alignItems: "center",
            marginBottom: 40,
          }}>
          <h3 style={{ color: "var(--link)" }}>Video {idx + 1}</h3>
          <div>
            <p style={{ color: "gray", marginLeft: 5 }}>Title</p>
            <TextField
              sx={{ width: 300, mb: 2 }}
              size="small"
              placeholder="How to..."
              value={vidLinks[index]?.vids[idx]?.title || ""}
              onChange={(e) => handleTitleChange(index, idx, e.target.value)}
            />
            <p style={{ color: "gray", marginLeft: 5 }}>Link</p>
            <TextField
              sx={{ width: 300 }}
              size="small"
              placeholder="https://youtube.com..."
              value={vidLinks[index]?.vids[idx]?.link || ""}
              onChange={(e) => handleLinkChange(index, idx, e.target.value)}
            />
          </div>
          <div>
            <p style={{ color: "gray", marginLeft: 5 }}>Thumbnail</p>
            <div
              style={{
                border: "dashed",
                borderWidth: 1,
                borderColor: "grey",
                height: 130,
                marginTop: 1,
                width: 230,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center",
                borderRadius: 5,
                cursor: "pointer",
              }}
              onClick={() => {
                setClickedIndex(idx);
                hiddenFileInputs.current[idx].click();
              }}>
              {vidLinks[index]?.vids[idx]?.thumbnail ? (
                <>
                  <img
                    src={
                      thumbs[idx]
                        ? URL.createObjectURL(thumbs[idx])
                        : SERVER_DOMAIN + vidLinks[index]?.vids[idx]?.thumbnail
                    }
                    style={{
                      width: "94%",
                      height: "90%",
                      objectFit: "cover",
                      borderRadius: 5,
                    }}
                  />
                </>
              ) : (
                <>
                  {thumbs[idx] ? (
                    <img
                      src={URL.createObjectURL(thumbs[idx])}
                      style={{
                        width: "94%",
                        height: "90%",
                        objectFit: "cover",
                        borderRadius: 5,
                      }}
                    />
                  ) : (
                    <>
                      <img src={addImageIcon} style={{ width: 55 }} />
                      <p style={{ color: "#888", fontSize: 13 }}>Click here to add an image</p>
                    </>
                  )}
                </>
              )}

              <input
                type="file"
                accept="image/png, image/jpeg"
                onChange={(e) => handleImageChange(e, idx)}
                ref={(el) => (hiddenFileInputs.current[idx] = el)}
                style={{ display: "none" }}
              />
            </div>
          </div>
        </div>
      ))}

      <div className="submitBTN" onClick={submitData}>
        Save Changes
      </div>
    </div>
  );
}
